import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import axios from 'axios'
import qs from 'qs'
import './assets/icon/iconfont-t.css';
import baseUrl from "@/constants";
import {Message} from "element-ui";
import { MessageBox } from 'element-ui';
import '../static/css/blue/theme/index.css';
import '@/assets/css/common.scss'

//引入Dialog可拖拽
import './assets/js/dialogDrag.js';

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);



import vueFilter from '@/common/filter'

import vuePrototype from '@/common/prototype'
vuePrototype.forEach((v,k)=>{
  Vue.prototype[k] = v;
})

vueFilter.forEach((v,k)=>{
  Vue.filter(k, v);
})

//防止按钮重复点击
Vue.directive('throttle', {
  bind: (el: any, binding: any) => {
    let throttleTime = binding.value; // 节流时间
    if (!throttleTime) { // 用户若不设置节流时间，则默认2s
      throttleTime = 2000;
    }
    let cbFun: any;
    el.addEventListener('click', (event: any) => {
      if (!cbFun) { // 第一次执行
        cbFun = setTimeout(() => {
          cbFun = null;
        }, throttleTime);
      } else {
        event && event.stopImmediatePropagation();
      }
    }, true);
  },
});


import AmapVue from '@amap/amap-vue';
import {userApi} from "@/api/organization";
import {debounced} from "@/common/public";
import {utils, write} from "xlsx";
import FileSaver from "file-saver";

AmapVue.config.version = '2.0'; // 默认2.0，这里可以不修改
AmapVue.config.key = '81dd5240958b5c57c19ceb8eb827bf8b';
Vue.use(AmapVue);

import { UTable, UTableColumn } from 'umy-ui';
Vue.component(UTable.name, UTable);
Vue.component(UTableColumn.name, UTableColumn);

// const QRCode = require('qrcodejs2');
// Vue.prototype.QRCode = QRCode ;

// import 'vue-draggable-resizable-gorkys/dist/VueDraggableResizable.css'

Vue.prototype.closePage = function(e: string){
  //清空detail中的form表单***************
  // let arr = [];
  // if(e){
  //   arr = e.split(",")
  // }else{
  //   arr = ['form'];
  // }
  // for(const f of arr){
  //   const form = this.$refs[f] as HTMLFormElement;
  //   if(form){
  //     form.resetFields();
  //   }
  // }
  //**********清空detail中的form表单end*******
  this.$root.$emit('closeTabs',this.$route.path);
}
Vue.prototype.exportExcel = function(callback: any, name: string){
  //如果找不到元素 说明还没加载出来 2秒后再次执行
  if(document.querySelector('#data-table') == undefined){
    setTimeout(() => {
      this.exportExcel(callback,name);
    }, 2000)
    return;
  }
  let tableDom = document.querySelector('#data-table') as any;
  tableDom = tableDom.cloneNode(true);
  const nodeList = tableDom.querySelectorAll('.export-del-el');
  const nodeListV2 = tableDom.querySelectorAll('.el-table__fixed');
  for (let key = 0; key < nodeList.length; key++) {
    nodeList[key].remove();
  }
  for (let key = 0; key < nodeListV2.length; key++) {
    nodeListV2[key].remove();
  }
  const wb = utils.table_to_book(tableDom, {
    raw: true,
    display: true,
  });
  const wbout = write(wb, {bookType: 'xlsx', bookSST: true, type: 'array'});
  try {
    FileSaver.saveAs(new Blob([wbout], {type: 'application/octet-stream'}), name)
  } catch (e) {
    if (typeof console !== 'undefined') console.log(e, wbout);
  }
  callback();
  return wbout;
}
axios.defaults.timeout = 900000; // 请求超时
axios.defaults.baseURL = baseUrl
axios.defaults.withCredentials = true;
const service = axios.create({
  withCredentials: true, // send cookies when cross-domain requests
  headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  transformRequest: function (data) {
    if(data!=undefined && typeof(data) === 'string'){
      return data;
    }
    return qs.stringify(data, {
      allowDots: true
    });
  }
});
service.interceptors.request.use(
    config => {
      if(store.state.Authorization){
        config.headers.Authorization = store.state.Authorization;
      }
      return config;
    },
    error => {
      return Promise.reject(error);
    }
);

const debouncedUse = debounced.use(toLogin, 600)
function toLogin(){
  const path = router.app.$route.path;
  // 公众号 跳出
  if(path.indexOf("/mp/") > -1){
    return;
  }
  MessageBox.alert("令牌过期，请重新登录", "提示",).then(()=>{
    const toPath = '/login';
    store.commit('signout');
    router.push(toPath);
  })
}
service.interceptors.response.use(
    response => {
      if(response.headers.authorization){
        // 处理Token。快过期时会颁发新的Token,需要更新本地的
        store.state.Authorization = response.headers.authorization;
        sessionStorage.setItem('Authorization', response.headers.authorization);
        userApi.getUserDetail().then(e=>{
          sessionStorage.setItem('AuthedUser', JSON.stringify(e.data.data));
          store.state.AuthedUser = e.data.data;
        });
      }
      if(response.data && response.data.result < 0){
        Message({
          dangerouslyUseHTMLString: true,
          type: "error",
          message: response.data.message
        })
      }
      return response;
    },
    error => {
      if (error.response) {
        const name = router.app.$route.name;
        if (error.response.status === 401 && name == "first") {
          const fullPath = router.app.$route.fullPath;
          const index = fullPath.lastIndexOf("?");
          const str = fullPath.substring(index, fullPath.length);
          let toPath = '/login' + (str.length>1?str:'');

          const path = router.currentRoute.path;
          if(path.search(/^\/mp\//) === 0){
            toPath = "/mp/login"
          }

          store.commit('signout');
          router.push(toPath);
        }else if (error.response.status === 401) {
          debouncedUse();
        } else if (error.response.status === 403) {
          // 提示无权限等
          // MessageBox.alert("您没有权限执行此操作", "操作提示")
          //.warning("您没有权限执行此操作")
          Message({
            type:"warning",
            message: "您没有权限执行此操作"
          })
        } else if (error.response.status === 404) {
          // 提示无权限等
          // MessageBox.alert("您没有权限执行此操作", "操作提示")
          // Message.error("未找到请求的接口。可能是服务暂时不可用。请稍等")
          Message({
            type:"error",
            message: "未找到请求的接口。可能是服务暂时不可用。请稍等"
          })
        } else {
          // 其他错误处理
          if(error.response.data && error.response.data.message){
            // Message.error(error.response.data.message);
            Message({
              type:"error",
              message: error.response.data.message
            })
          } else {
            // Message.error("请求服务器失败，请稍后再试")
            Message({
              type:"error",
              message: "请求服务器失败，请稍后再试"
            })
          }
        }
      }
      return Promise.reject(error.response.data)
    }
)

const requestImage = function(config: any) {
  return service(Object.assign({}, config, {
    headers: { 'Content-Type': 'multipart/form-data' },
    transformRequest: (data: any) => {return data;},
    timeout: 1000*60*10
  }))
}

const requestJson = function(config: any) {
  return service(Object.assign({}, config, {
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    transformRequest: (data: any) => {return JSON.stringify(data);}
  }))
}

const debouncedUse2 = debounced.use(updateToken, 600);
function updateToken(){
  const name = router.app.$route.name as string;
  const path = router.app.$route.path as string;
  // 公众号 跳出
  if(path.indexOf("/mp/") > -1){
    return;
  }
  if(['Login', 'register-user', 'register-company', 'register-company-v2', 'change-mechanism-select', 'change-mechanism-index', 'register-company-select', 'WechatAuthorize','change-mobile', 'mobileImg', 'Maps','MapsList','MapsList2',
    'Statistics_Indexs','Statistics_Approval_Indexs','Maps0s','Maps1s','MapsLists','MapsList2s','Rules_rules_Chart_Alls','Statistics_rulesDetails','External_OaProject','External_OaRecord',
  'Integrity_QRcode', 'helpManual'].indexOf(name) == -1){
    userApi.getUserConfig("aaaa");
  }
}
setTimeout(()=>{
  const main = window.document.getElementById("app");
  if(main){
    main.onclick = function(){
      debouncedUse2()
    }
  }
},1000)
Vue.config.productionTip = false
Vue.prototype.$axios=service;
Vue.prototype.$qs=qs;
export default service;
export {service,requestImage,requestJson} ;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
